// extracted by mini-css-extract-plugin
module.exports = {"tour":"Tour_tour__3DVu5"};